import {useState} from "react";
import {useQuery} from "react-query";
import axios from "services/axios";

async function getTitles(id, filter) {
	const {data} = await axios.get(`/misc/titles`, {params: filter});

	return data;
}

export function useTitles() {
	const [filter, filterTitles] = useState({
		page: 1,
		search: null,
		limit: 10,
	});
	const [titleId, titleById] = useState(null);
	const fallback = [];
	const {
		data = fallback,
		isLoading,
		isError,
		error,
	} = useQuery(["titles", titleId, filter], async () => getTitles(titleId, filter));

	return {data, isLoading, isError, error, filter, filterTitles, titleById};
}
